import {observer} from "mobx-react-lite";
import React, {useEffect, useState} from "react";
import {Link, match} from "react-router-dom";
import RuleGroup from "../../store/entities/rules/RuleGroup";
import ProductRulesApi from "../../api/ProductRulesApi";
import {RulesGroupComponent} from "../../components/rule/RulesGroupComponent";
import {RulesGroupsContentLoader} from "../generalOfferFields/GeneralOfferPage";
import {appPages} from "../../App";
import AttributesApi from "../../api/AttributesApi"
import {noticeController} from "../../utils/NoticeController"

export const CategoryAttributesPage = observer(({match}: { match: match<{ category_id: string }> }) => {
    const category_id = match.params.category_id;
    const [group, setGroup] = useState<RuleGroup | null>(null);

    const updateAttributes = () => {
        const l_group = new RuleGroup({
            name: "Идет обновление",
            rules: []
        });
        setGroup(l_group)
        AttributesApi.updateAttributes(Number(category_id)).then(
            (result) => {
                const groupOfRules = result.data.data
                const new_group = new RuleGroup(groupOfRules);
                setGroup(new_group)
            }
        )
    }

    const saveGroup = (group:RuleGroup | null) => {
        const data = []
        if(group) {
            for (const rule of group.rules) {
                if(rule.child_rules.length > 0) {
                    if(rule.type === 'ozonOutputNameTemplate') {

                        data.push({
                            'input_type': rule.input.rule ? rule.input.rule.input_type : 'delete',
                            'input_name': rule.input.rule ? rule.input.rule.input_name : 'delete',
                            'input_unit': rule.input.input_unit_option?.value,
                            'output_type': rule.type,
                            'ozon_attribute_id': rule.ozon_attribute_id,
                            'ozon_category_id': rule.category_id
                        })

                    }
                    for (const child of rule.child_rules) {

                        data.push({
                            'input_type': child.input.rule ? child.input.rule.input_type : 'delete',
                            'input_name': child.input.rule ? child.input.rule.input_name : 'delete',
                            'input_unit': child.input.input_unit_option?.value,
                            'output_type': child.type,
                            'ozon_attribute_id': child.ozon_attribute_id,
                            'ozon_category_id': child.category_id
                        })

                    }
                } else {

                    data.push({
                        'input_type': rule.input.rule ? rule.input.rule.input_type : 'delete',
                        'input_name': rule.input.rule ? rule.input.rule.input_name : 'delete',
                        'input_unit': rule.input.input_unit_option?.value,
                        'output_type': rule.type,
                        'ozon_attribute_id': rule.ozon_attribute_id,
                        'ozon_category_id': rule.category_id
                    })

                }
            }

            ProductRulesApi.saveAll(data).then(result=> {
                noticeController.success = ["Сохранено"]
                setTimeout(()=>noticeController.clearSuccess(), 1000)
                const groupsOfRules = result.data.data
                if(groupsOfRules) {
                    const new_group = new RuleGroup(groupsOfRules[0]);
                    setGroup(new_group)
                }

            })

        }
    }

    useEffect(() => {
        ProductRulesApi.getCategoryOutputs(+category_id).then(
            (result) => {
                const groupOfRules = result.data.data
                const group = new RuleGroup(groupOfRules);
                setGroup(group)
            }
        )
    }, [])
    return (
        <>
            <div>
                <Link className={"underline gray"}
                      to={appPages.offerAttributes + '/'}>
                    <i className="fa fa-angle-left"/> К списку категорий
                </Link>
            </div>
            {group ? <RulesGroupComponent
                updateAttributes={updateAttributes}
                saveGroup={saveGroup}
                category_id={category_id}
                group={group}/> : <RulesGroupsContentLoader/>}
        </>
    )
})